module.exports = __webpack_public_path__ + "img/instagram.d2c03bda.svg";